import { buffers } from 'redux-saga';
import { take, all, fork, call, put, actionChannel } from 'redux-saga/effects';
import { dropdownFetchListInProgress, dropdownFetchListDone } from './actions';
import * as sagasDropdown from '../../../../../sagas/dropdown/sagasDropdown';

export default function* (feathersApp) {
  return yield all([
    fork(dropdownMountSaga, feathersApp)
  ]);
}




function* dropdownMountSaga(feathersApp) {
  const buffer = buffers.expanding();
  const channel = yield actionChannel(['FETCH_DROPDOWN_MOUNT'], buffer);
  while (true) {

    const action = yield take(channel);

    if (action) {

      const { payload } = action;

      const {
        id,
        key,
        fields,
        filter,
        preload,
        searchTerm,
        searchParams = {},
        type: dropdown_type,
      } = payload || {};

      yield put(dropdownFetchListInProgress(key));

      yield fork( handleDropdownMountSingle, feathersApp, {
        id,
        key,
        fields,
        filter,
        preload,
        searchTerm,
        dropdown_type,
        searchParams,
      });
    }
  }
}




function* handleDropdownMountSingle(feathersApp, params) {
  const { dropdown_type, key } = params;
  try {
    const list = yield call(sagasDropdown.resolveDropdownCall, feathersApp, dropdown_type, params)
    yield put(dropdownFetchListDone(key, null, list));
  } catch(err) {
    console.error("@handleDropdownMountAll: ", err.message || JSON.stringify(err));
    yield put(dropdownFetchListDone(key, null, []));

  }
}